import React from 'react';
import Movie from './Movie';

const Movies = ({ movies, onLoadMore, hasMore, isLoading, total }) => {
  if (!movies.length && !isLoading) {
    return <p>No movies found.</p>;
  }
  // We load up to 50 titles so we show a "+"
  // If there are more.

  return (
    <>
      <div className="movie-collage">
        {movies.map(movie => (
          <Movie key={movie.id} movie={movie} />
        ))}
      </div>
      {hasMore && (
        <div className="control-buttons">
          <button onClick={onLoadMore} disabled={isLoading}>
            {isLoading ? 'Loading...' : 'More'}
          </button>
          <p>Showing {movies.length} of {total}{total === 50 ? '+' : ''}</p>
        </div>
      )}
    </>
  );
};

export default Movies;
